var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgNftRoyalRevokeBan(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.12 24.44C36.317 33.108 24.053 46 12.89 46a16.14 16.14 0 01-4.87-1.027 6.325 6.325 0 01-1.468-.704 6.938 6.938 0 01-3.3-5.984v-.645c0-.25.073-.514.131-.807.063-.292.141-.581.235-.865 2.025-7.334 7.056-7.583 8.993-16.779A12.965 12.965 0 0124.918 8.922a12.282 12.282 0 013.08.264l.353.088c.44.024.878.093 1.305.206a12.997 12.997 0 018.465 14.96z",
    fill: "#FAB14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.27 22.723c-1.79 8.61-13.658 21.135-24.66 21.546a6.937 6.937 0 01-3.36-5.984v-.646c0-.25.073-.513.132-.806.063-.293.141-.582.235-.866 2.024-7.333 7.056-7.582 8.992-16.778A12.966 12.966 0 0124.919 8.922a12.981 12.981 0 016.352 13.801z",
    fill: "#FFD966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.106 9.142c.968-5.28 7.041-10.81 18.587-3.93 0 0-5.692 6.086-13.042 5.617a18.587 18.587 0 01-5.428-.719c-.22-.117-.146-.777-.117-.968z",
    fill: "#70CC70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.94 8.526C20.75 13 41.392 20.494 42.052 27.08a21.82 21.82 0 003.198-10.413c0-5.47-8.787-13.435-17.31-8.14z",
    fill: "#7EE67E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 19.122c1.363-2.403 1.302-5.011-.136-5.826-1.438-.815-3.708.473-5.07 2.876s-1.301 5.012.137 5.827c1.438.814 3.708-.473 5.07-2.877z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.25 2)",
    d: "M0 0h42v44H0z"
  })))));
}
export default SvgNftRoyalRevokeBan;